import { Navigate, useLocation, matchPath } from "react-router-dom";

import { useAuthData } from "@/store/hooks";

import {
  HOProtectedRoutes,
  SAProtectedRoutes,
  MainSailAdminProtectedRoutes,
} from "./protectedRoutes";

interface RoleBasedRouteProps {
  children: React.ReactNode;
}

const RoleBasedRoute: React.FC<RoleBasedRouteProps> = ({ children }) => {
  const { userType } = useAuthData();
  const location = useLocation();

  // Anything else (homeowners) falls back to the homeowner routes.
  const routesByUserType: Record<string, typeof SAProtectedRoutes> = {
    ADMIN: SAProtectedRoutes,
    SUPER_ADMIN: SAProtectedRoutes,
    MAINSAIL_ADMIN: MainSailAdminProtectedRoutes,
  };
  const userRoutes = routesByUserType[userType] ?? HOProtectedRoutes;

  const hasAccess = userRoutes.some((route) => {
    const match = matchPath(
      {
        path: route.path,
        end: true,
      },
      location.pathname
    );
    return match !== null;
  });

  // If user doesn't have access to this route, redirect to dashboard or 404
  if (!hasAccess) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default RoleBasedRoute;
